import { AuthGuard } from '@repo/user-session';
import { useRouter } from 'next/router';

import Layout from '@/components/layout/Layout';
import { useRightInquiryTextButton } from '@/components/tax-refund/common/hooks/use-create-header-props';
import IndisSelectJoinCertificateContent from '@/components/tax-refund/individual/JointCertificate/select/IndisSelectJoinCertificateContent';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

const IndisSelectJointCertificatePage = () => {
  const router = useRouter();
  const rightInquiryButton = useRightInquiryTextButton(SUPPORT_BOT_LINK.인증정보입력);

  const handleClickLeft = () => {
    router.back();
  };

  return (
    <AuthGuard>
      <Layout leftIcon={{ icon: 'back', onClick: handleClickLeft }} rightTextButton={rightInquiryButton}>
        <IndisSelectJoinCertificateContent />
      </Layout>
    </AuthGuard>
  );
};

export default IndisSelectJointCertificatePage;
